import { createPayloadAction } from '@r/helpers/redux-helpers'
import { FsCore } from '@t/fs-core'

export interface SetCalculatorPayload {
  id: string
  calculator: FsCore.CalculatorState
}
export const setCalculator = createPayloadAction<SetCalculatorPayload>('SET_CALCULATOR')
export interface UseCalculatorPayload {
  calculatorId: string
  usedById: string
}
export const useCalculator = createPayloadAction<UseCalculatorPayload>('USE_CALCULATOR')
